import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { createPortal } from 'react-dom';
import { Outlet, useLocation } from "react-router-dom";
import { colors, frames, useMediaQuery } from "../../Styles";
import { Overlay, LogoDisplay, MenuButton } from '../../Components';
import { ToolsMenu } from '../Menus';
import { ToolsMenu_Pages } from '../pages';

// #region | ToolspanelLayoutDesktop
export const ToolspanelLayoutDesktop = () => {
  const {t} = useTranslation()
  const location = useLocation();
  const [subMenu, setSubMenu] = useState<boolean>(true) 
  
  useEffect(() => {
    if (location.pathname.includes("/users") || location.pathname.includes("/farms") || location.pathname.includes("/graphQL")) {
      setSubMenu(false);
    }
  }, [location]);

  return (
    <frames.ToolsPanel>
      <LogoDisplay goBackBtn={t("buttons.goBack", {defaultValue: "Go Back"})} overrides={{ gridArea: "logoDisplay" }} />
      <ToolsMenu overrides={{ gridArea: "globalMenu" }} aicoClick={() => {setSubMenu(true)}} />
      <div style={{ gridArea: "systemMenu", backgroundColor: colors.greyDarkPrimary, borderRadius: "0px 0px 10px 10px" }}>
        { subMenu ? <ToolsMenu subMenu /> : undefined }
      </div>
      <div style={{ gridArea: "page_outer", overflow: "hidden"}}>
        <Outlet /> 
      </div>
    </frames.ToolsPanel>
  );
};
// #endregion

// #region | ToolspanelLayoutMobile
const ToolspanelLayoutMobile = () => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [subMenu, setSubMenu] = useState<boolean>(true) 

  const handleMenuClick = (id: number ) => {
    if (id === 0) {
      setSubMenu(true);
    } else if (id >= 4) {
      setMenuOpen(false)
    } else {
      setSubMenu(false);
      setMenuOpen(false);
    }
  };

  useEffect(() => {
    if (location.pathname.includes(ToolsMenu_Pages.log)) {
      setSubMenu(true);
    }
  }, [location]);

  const toggleComponents = () => {
    setMenuOpen(!menuOpen);
  };

  return (<>
    <MenuButton menuState={menuOpen} onClick={toggleComponents} />

    <frames.FullViewPanel>
      {menuOpen && createPortal(<>
        <Overlay overrides={{ zIndex: menuOpen ? 99999 : 0, blur: true }}
          content={
            <frames.Menu_Outer style={{ boxSizing: "border-box", display: "grid", gridTemplateColumns: "1fr", gridTemplateRows: "150px 1fr auto", rowGap: "10px", position: "relative", zIndex: "999999", padding: "10px", height: "100%", width: "100%" }}>
              <div style={{ gridArea: "1/1/2/2" }}><LogoDisplay ChooseSite selectedPage={ToolsMenu_Pages.log} overrides={{ borderRadius: "10px" }} /></div>
              <frames.Menu_Inner $gridArea='2/1/3/2'>{subMenu && <ToolsMenu subMenu={subMenu} onMenuClick={handleMenuClick} />}</frames.Menu_Inner>
              <frames.Menu_Inner $gridArea='3/1/4/2'><ToolsMenu onMenuClick={handleMenuClick} /></frames.Menu_Inner>
            </frames.Menu_Outer>
          }
        />
      </>, document.body)}
      <div style={{ gridArea: "page_outer", overflow: "hidden" }}>
        <Outlet />
      </div>
    </frames.FullViewPanel>
  </>);
};
// #endregion 

const ToolspanelLayout = () => {
  const mobile = useMediaQuery(`(max-width: 1000px)`);
  return ( <>
    {mobile ? <ToolspanelLayoutMobile/> : <ToolspanelLayoutDesktop/>}
  </> )
}

export default ToolspanelLayout;